import React from 'react';
import PropTypes from 'prop-types';
import { Paper, Typography, Button } from '@material-ui/core';
import { showValue } from '../../utils/HelpPreinforme';
import preinformeStyles from '../preinforme/preinformeStyles';
import { resolveIniciales } from '../preinforme/CabeceraPreinforme';
import medicionesStyles from './medicionesStyles';

/**
 * Cabecera del paciente de la vista de registro de mediciones: avatar con
 * iniciales, nombre, documento y botones Ver preinforme (opcional) y Volver.
 */
const CabeceraMediciones = ({ personalData, onVolver, onVerPreinforme }) => {
	const classes = preinformeStyles();
	const local = medicionesStyles();

	return (
		<Paper className={`${classes.headerPaper} ${local.headerPaper}`}>
			<div className={local.accentLine} />
			<div className={classes.headerTopRow}>
				<div className={`${classes.headerIdentity} ${local.headerIdentity}`}>
					<div className={classes.headerAvatar} aria-hidden="true">
						{resolveIniciales(personalData.nombre)}
					</div>
					<div className={local.headerNameBox}>
						<Typography variant="h6" component="h2" className={`${classes.headerName} ${local.headerName}`}>
							{personalData.nombre}
						</Typography>
					</div>
				</div>
				<div className={local.headerActions}>
					{onVerPreinforme && (
						<Button
							variant="outlined"
							color="default"
							size="small"
							className={classes.buttonNoTransform}
							onClick={onVerPreinforme}
						>
							Ver preinforme
						</Button>
					)}
					<Button
						variant="outlined"
						color="default"
						size="small"
						className={classes.buttonNoTransform}
						onClick={onVolver}
					>
						Volver
					</Button>
				</div>
			</div>
			<Typography variant="caption" className={classes.metaLabel}>
				Documento
			</Typography>
			<Typography className={`${classes.metaValue} ${local.headerName}`}>
				{showValue(personalData.documento)}
			</Typography>
		</Paper>
	);
};

CabeceraMediciones.propTypes = {
	personalData: PropTypes.shape({
		nombre: PropTypes.string,
		documento: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	}).isRequired,
	onVolver: PropTypes.func.isRequired,
	onVerPreinforme: PropTypes.func,
};

export default CabeceraMediciones;
